import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { FiCheckCircle, FiAlertCircle, FiInfo, FiX } from 'react-icons/fi';

const AdminToastContext = createContext({ dismiss: () => {} });

const styles = {
  success: { icon: FiCheckCircle, className: 'border-green-200 bg-green-50 text-green-800' },
  error: { icon: FiAlertCircle, className: 'border-red-200 bg-red-50 text-red-800' },
  info: { icon: FiInfo, className: 'border-blue-200 bg-blue-50 text-blue-800' },
};

export const AdminToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const dismiss = useCallback(
    (id) => setToasts((current) => current.filter((toast) => toast.id !== id)),
    []
  );

  useEffect(() => {
    const handleToast = ({ detail }) => {
      const id = `${Date.now()}-${Math.random()}`;
      setToasts((current) => [...current.slice(-3), { id, ...detail }]);
      setTimeout(() => dismiss(id), 4500);
    };
    window.addEventListener('admin:toast', handleToast);
    return () => window.removeEventListener('admin:toast', handleToast);
  }, [dismiss]);

  return (
    <AdminToastContext.Provider value={{ dismiss }}>
      {children}
      <aside className="fixed right-4 top-4 z-[100] w-full max-w-sm space-y-2" aria-live="polite">
        {toasts.map((toast) => {
          const style = styles[toast.type] || styles.info;
          const Icon = style.icon;
          return (
            <div key={toast.id} className={`flex items-start gap-3 rounded-xl border p-3 shadow-lg ${style.className}`}>
              <Icon className="mt-0.5 flex-shrink-0" size={18} />
              <p className="flex-1 text-sm font-medium">{toast.message}</p>
              <button type="button" onClick={() => dismiss(toast.id)} aria-label="Dismiss notification">
                <FiX size={16} />
              </button>
            </div>
          );
        })}
      </aside>
    </AdminToastContext.Provider>
  );
};

export const useAdminToast = () => useContext(AdminToastContext);
